import Cookies from 'js-cookie';

import { getAppAuthBoundary } from '../modules/auth';

/**
 * Raw legacy `access_token` cookie reader (pre-#3888 behavior, unchanged).
 *
 * Deliberately NOT routed through the boundary: `../modules/auth/legacy-session-adapter.ts` reads
 * the same cookie on the boundary's behalf, so this stays the raw legacy read. Callers that need mode-neutral (SSO-or-legacy) token access per FR-006/
 * FR-008 should use {@link getBearerAccessToken} below instead; this export stays as the narrow
 * legacy-cookie primitive the adapter (and a few other not-yet-migrated call sites outside this
 * task's PR scope — `src/shared/apollo.ts`, the RTK Query API clients, `src/modules/system/redux/
 * actions.ts` — see T028/T030/T031) still depend on.
 */
export function getAuthToken() {
  return Cookies.get('access_token');
}

/**
 * Mode-neutral Bearer access token (T029; FR-006, FR-008, FR-009): resolves through the one
 * dashboard authentication boundary instead of reading the legacy cookie directly, so it returns
 * the correct token whether the current session is SSO or legacy without this — or any caller of
 * {@link authenticated} — branching on authentication mode.
 */
export function getBearerAccessToken() {
  return getAppAuthBoundary().getAccessToken();
}

export function authenticated(api, config = {}) {
  const accessToken = getBearerAccessToken();
  api.setHeader('Authorization', `Bearer ${accessToken}`);
  api.setHeader('Cache-Control', config?.fromCache === false ? 'no-cache' : 'public, max-age=30, s-maxage=30');

  return api;
}
